import React from "react";

import styled from "styled-components/macro";

export default function UpdatingPill() {
  return <Updating>Updating</Updating>;
}

const Updating = styled.div`
  position: absolute;
  top: -15px;
  left: 28px;
  font-size: 18px;
  font-weight: 600;
  color: #15436a;
  padding: 3px 12px;
  border-radius: 16px;
  background: hsl(0 0% 100% / 0.75);
  text-shadow: none;
  filter: drop-shadow(1px 2px 3px hsl(0 0% 0% / 0.9));
  z-index: 10;
`;
